<div *ngIf="!!formula" class="color-pill-image" [class.transparent]="!showTexture" [style.background-color]="formula.rgb" (click)="toggleTexture()">
  <img src="assets/images/swatch-texture-4-long.png" alt="hair texture pattern">
</div>
